// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"93ac6fce7652d32c2066","303":"dc37181722dbe3619135","495":"22ac6e557d5d818065c0"}[chunkId] + ".js";
};